// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';

// Hooks
import useMatchmakingStepsOptions from '../../../hooks/useMatchmakingStepsOptions';

// Styles
import StepsStyles from './steps.styles';

export default function Steps({ layout, predefined }) {
  const matchmakingStepsOptions = useMatchmakingStepsOptions();

  const data = predefined ? matchmakingStepsOptions : layout;
  let heading = data?.heading;
  let subheading = data?.subheading;
  const steps = data?.steps;

  const spaceBelow = layout?.spaceBelow;

  if (predefined) {
    heading = layout?.overrideHeading ? layout?.heading : data?.heading;
    subheading = layout?.overrideSubheading
      ? layout?.subheading
      : data?.subheading;
  }

  return (
    <StepsStyles spaceBelow={spaceBelow}>
      <Container>
        {heading && <h2 className="heading large">{heading}</h2>}
        {subheading && <h3 className="subheading large">{subheading}</h3>}
      </Container>

      {steps && (
        <ol className="steps">
          {steps.map((step) => (
            <li key={uuid()}>
              <Container>
                <div className="inner">
                  {step?.icon && (
                    <div className="icon-wrap">
                      <img
                        className="icon"
                        src={step?.icon?.localFile?.publicURL}
                        alt={step?.icon?.altText || ' '}
                        width={40}
                        height={40}
                      />
                    </div>
                  )}

                  <div className="content-wrap">
                    <h3 className="heading">{step?.heading}</h3>
                    <p>{step?.text}</p>
                  </div>
                </div>
              </Container>
            </li>
          ))}
        </ol>
      )}
    </StepsStyles>
  );
}

Steps.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
    spaceBelow: PropTypes.bool,
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.shape({
          altText: PropTypes.string,
          localFile: PropTypes.shape({
            publicURL: PropTypes.string,
          }),
        }),
        heading: PropTypes.string,
        text: PropTypes.string,
      }),
    ),
    overrideHeading: PropTypes.bool,
    overrideSubheading: PropTypes.bool,
  }),
  predefined: PropTypes.string,
};

Steps.defaultProps = {
  layout: {},
  predefined: null,
};
